/**
 * Icon identifiers and hover tooltip copy for medical PA order status badges.
 */
export enum IconNames {
  ORDER_PROCESS_SUCCESS = "order_process_success",
  ORDER_PROCESS_YET_TO_START = "order_process_yet_to_start",
  ORDER_PROCESS_IN_PROGRESS = "order_process_in_progress",
  ORDER_PROCESS_SUCCESS_BY_AGENT = "order_process_success_by_agent",
  ORDER_IN_REVIEW = "order_in_review",
  ORDER_REVIEW_APPROVED = "order_review_approved",
  ORDER_REVIEW_REJECTED = "order_review_rejected",
  AGENT_ORDER_REVIEW_PENDING = "agent_order_review_pending",
  /** Shown when an agent-raised query is open on the order. */
  AGENT_ORDER_QUERY_RAISED = "agent_order_query_raised",
}
/** Human-readable tooltip text keyed to {@link IconNames}. */
export enum IconHoverText {
  ORDER_PROCESS_SUCCESS = "Completed by Human",
  ORDER_PROCESS_YET_TO_START = "Yet to Start",
  ORDER_PROCESS_IN_PROGRESS = "In Progress",
  ORDER_PROCESS_SUCCESS_BY_AGENT = "Completed by Agent",
  ORDER_IN_REVIEW = "Order In Review",
  ORDER_REVIEW_APPROVED = "Review Pass",
  ORDER_REVIEW_REJECTED = "Review Reject",
  AGENT_ORDER_REVIEW_PENDING = "Review Pending",
  /** Tooltip for {@link IconNames.AGENT_ORDER_QUERY_RAISED}. */
  AGENT_ORDER_QUERY_RAISED = "Query Raised By Agent",
}
